import React from "react";
import {
  Contracts as ContractsIcon,
  Guardrails,
  Workflow
} from "@dreamhub/designsystem/icons";
import DraggableStageRow from "@/pages/settings/components/shared/stageStudio/DraggableStageRow";
import CountBadge from "@/pages/settings/components/shared/stageStudio/CountBadge";
import { OnboardingStage } from "@/pages/settings/components/contractsSettings/types";
import { getOnboardingStageColor } from "../colors";

const TRANSLATION_KEY = "settings.contracts.onboardingStudio.stages";

interface Props {
  item: OnboardingStage;
  index: number;
  isDragDisabled?: boolean;
  isLast?: boolean;
}

const OnboardingStageRow: React.FC<Props> = ({
  item,
  index,
  isDragDisabled,
  isLast
}) => (
  <DraggableStageRow
    item={{ id: item.id, name: item.name }}
    index={index}
    isDragDisabled={isDragDisabled}
    isLast={isLast}
    color={getOnboardingStageColor(item.stageColor)}
    badges={
      <>
        <CountBadge
          count={item.workflowsCount}
          icon={<Workflow />}
          translationKey="workflow"
          tPrefix={TRANSLATION_KEY}
        />
        <CountBadge
          count={item.guardrailsCount}
          icon={<Guardrails />}
          translationKey="guardrail"
          tPrefix={TRANSLATION_KEY}
        />
        <CountBadge
          count={item.inProgressContractsCount}
          icon={<ContractsIcon />}
          translationKey="contract"
          tPrefix={TRANSLATION_KEY}
        />
      </>
    }
  />
);

export default OnboardingStageRow;
